import React from "react";

class Tools extends React.Component {
	render() {
		return (
			<div className="SoftList">
				<ul>
					{this.props.text.map((x) => {
						return <li key={x}>{x}</li>;
					})}
				</ul>
			</div>
		);
	}
}

export default Tools;



// WEBPACK FOOTER //
// ./src/components/Tools.js